<p class="center_text" mat-dialog-title>Wrong order of dates</p>

<div mat-dialog-actions align="center">
    <button class="center" mat-stroked-button color="warn" type="submit" (click)="close()">
    <mat-icon>close</mat-icon>
    </button>
</div>